import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

export function TeamSummaryErrorTable({
  errors,
}: {
  errors: {
    firstName: string;
    lastName: string;
    email: string;
    reason: string;
  }[];
}) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <Table
      variant="simple"
      size="sm"
      sx={{
        'th, td': {
          border: '1px solid',
          borderColor: 'gray.200',
        },
        th: {
          bg: 'gray.50',
          fontWeight: 'bold',
          textTransform: 'uppercase',
        },
      }}
    >
      <Thead>
        <Tr>
          <Th>First Name</Th>
          <Th>Last Name</Th>
          <Th>Email</Th>
          <Th>Reason</Th>
        </Tr>
      </Thead>
      <Tbody>
        {errors.map((err, idx) => (
          <Tr key={idx}>
            <Td>{err.firstName}</Td>
            <Td>{err.lastName}</Td>
            <Td>{err.email}</Td>
            <Td>
              <Box w="250px">
                <Text whiteSpace="pre-wrap" wordBreak="break-word">
                  {err.reason}
                </Text>
              </Box>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
